import React from 'react'

const FullPageLoader = ({ loading }) => {
    return (
        <>
            {
                loading &&
                <div className="absolute w-full h-full top-0 left-0 bg-black/30 z-[29]">
                    <div className="w-full h-full flex items-center justify-center gap-2 text-gray-500">
                        <span className="h-10 w-10 block rounded-full border-[6px] border-t-primary animate-spin"></span>
                    </div>
                </div>
            }
        </>
    )
}

export default FullPageLoader